import { Typography } from '@persona-id/design-tokens';
import { Link } from 'react-router-dom-v5-compat';
import { SPACINGS } from 'shared/styles/variables';
import styled from 'styled-components';

import { COLORS } from 'dashboard/styles/variables';
import IconChevron from 'images/icons/chevron.svg';

const MenuItem = styled(Link)`
  cursor: pointer;

  ${Typography.TextMediumBold};
  color: ${COLORS.black};

  padding: ${SPACINGS.base * 3}px ${SPACINGS.base * 2}px;
  border-bottom: 1px solid ${COLORS.gray20};

  display: flex;
  justify-content: space-between;
  align-items: center;

  &:hover {
    background-color: ${COLORS.gray4};
  }
`;
const MenuItemDivider = styled('div')`
  padding: ${SPACINGS.base * 3}px ${SPACINGS.base * 2}px;
  padding-bottom: ${SPACINGS.base * 6}px;

  border-bottom: 1px solid ${COLORS.gray20};
  cursor: auto;
`;
const StyledIconChevron = styled(IconChevron)`
  rect[stroke],
  path[stroke] {
    stroke: ${COLORS.black};
  }
`;

interface ThemeEditorNavProps {
  showStartPage: boolean;
  showSelectCountryPage: boolean;
  showDocumentsUploadPage: boolean;
  showTerminalPages: boolean;

  // 3.0 temp - remove when screen builder implemented
  showStartLogoPage?: boolean;
}

const ThemeEditorNav = ({
  showStartPage,
  showSelectCountryPage,
  showDocumentsUploadPage,
  showTerminalPages,
  showStartLogoPage,
}: ThemeEditorNavProps) => {
  const showSubPages =
    showStartPage || showSelectCountryPage || showDocumentsUploadPage || showTerminalPages;

  return (
    <div>
      {showStartLogoPage && (
        <ClickableMenuItem
          label='Start Page Title'
          route='start-page-title'
          dataTest='theme-editor-nav__start-page-title'
        />
      )}
      <ClickableMenuItem label='Color' route='color' dataTest='theme-editor-nav__color' />
      <ClickableMenuItem label='Font' route='font' dataTest='theme-editor-nav__font' />
      <ClickableMenuItem label='Buttons' route='buttons' dataTest='theme-editor-nav__buttons' />
      <ClickableMenuItem label='Advanced' route='advanced' dataTest='theme-editor-nav__advanced' />
      {showSubPages && <MenuItemDivider />}
      {showStartPage && (
        <ClickableMenuItem
          label='Start page'
          route='start-page'
          dataTest='theme-editor-nav__start-page'
        />
      )}
      {showSelectCountryPage && (
        <ClickableMenuItem
          label='Select country page'
          route='select-country-page'
          dataTest='theme-editor-nav__select-country-page'
        />
      )}
      {showDocumentsUploadPage && (
        <ClickableMenuItem
          label='Document upload page'
          route='documents-upload-page'
          dataTest='theme-editor-nav__documents-upload-page'
        />
      )}
      {showTerminalPages && (
        <>
          <ClickableMenuItem
            label='Completion page'
            route='completion-page'
            dataTest='theme-editor-nav__completion-page'
          />
          <ClickableMenuItem
            label='Failure page'
            route='failed-page'
            dataTest='theme-editor-nav__failed-page'
          />
        </>
      )}
    </div>
  );
};

export default ThemeEditorNav;

interface ClickableMenuItemProps {
  label: string;
  route: string;
  dataTest: string;
}

const ClickableMenuItem = ({ label, route, dataTest }: ClickableMenuItemProps) => {
  return (
    <MenuItem id={dataTest} data-test={dataTest} to={route}>
      {label}
      <StyledIconChevron />
    </MenuItem>
  );
};
